<div class="main-page cadastros">
  <div class="container-fluid">
    <app-title>{{ title ? title : "Inserir novo" }} </app-title>
    <mat-tab-group>
      <mat-tab label="Dados">
        <ng-template matTabContent>
          <div class="row mt-3 no-gutters p-4 row-form">
            <div class="col-12">
              <form [formGroup]="userForm" (ngSubmit)="submitForm()">
                <h2 class="mb-3">Novo Usuário</h2>
                <div class="form-row">
                  <div class="form-group col-lg-6">
                    <mat-form-field appearance="outline">
                      <mat-label>Login*</mat-label>
                      <input
                        autocomplete="off"
                        autofocus
                        pattern="[0-9a-zA-Z]*"
                        formControlName="cdUsuario"
                        matInput
                        placeholder="Login"
                        maxlength="100"
                        [readonly]="!!userId"
                      />
                    </mat-form-field>

                    <validation-errors
                      [form]="userForm"
                      controlLabel="Login"
                      controlName="cdUsuario"
                    >
                    </validation-errors>
                  </div>
                  <div class="form-group col-lg-6">
                    <mat-form-field appearance="outline">
                      <mat-label>Nome do usuário*</mat-label>
                      <input
                        formControlName="nmUsuario"
                        matInput
                        placeholder="Nome do usuário"
                        maxlength="100"
                      />
                    </mat-form-field>
                    <validation-errors
                      [form]="userForm"
                      controlLabel="Nome do usuário"
                      controlName="nmUsuario"
                    >
                    </validation-errors>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-lg-6">
                    <mat-form-field appearance="outline">
                      <mat-label>E-mail*</mat-label>
                      <input
                        formControlName="dsEmail"
                        matInput
                        placeholder="E-email"
                        maxlength="100"
                      />
                    </mat-form-field>
                    <validation-errors
                      [form]="userForm"
                      controlLabel="E-mail"
                      controlName="dsEmail"
                    >
                    </validation-errors>
                  </div>

                  <div class="form-group col-lg-3">
                    <mat-form-field appearance="outline">
                      <mat-label>Matricula</mat-label>
                      <input
                        formControlName="nrMatricula"
                        matInput
                        maxlength="4"
                        placeholder="Matricula"
                        pattern="[0-9]*"
                        required
                      />
                    </mat-form-field>
                    <span
                      class="alert-danger"
                      *ngIf="!userForm.get('nrMatricula').valid"
                    >
                      Matricula é um campo numérico e obrigatório!
                    </span>
                  </div>

                  <div class="form-group col-lg-3" *ngIf="!userId">
                    <mat-form-field appearance="outline">
                      <mat-label>Senha*</mat-label>
                      <input
                        autocomplete="off"
                        [type]="hide ? 'password' : 'text'"
                        formControlName="cdSenha"
                        matInput
                        placeholder="Senha"
                        maxlength="100"
                      />
                      <mat-icon matSuffix (click)="hide = !hide">{{
                        hide ? "visibility_off" : "visibility"
                      }}</mat-icon>
                    </mat-form-field>
                    <validation-errors
                      [form]="userForm"
                      controlLabel="Senha"
                      controlName="cdSenha"
                    >
                    </validation-errors>
                  </div>

                  <!-- Check Box da permissão no filtro geral -->
                  <div class="form-group col-12">
                    <mat-checkbox
                      formControlName="generalFilterPermission"
                      [disabled]="true"
                      color="primary"
                      [checked]="true"
                    >
                      Pode utilizar o filtro geral?
                    </mat-checkbox>
                  </div>

                  <div
                    class="form-group col-12"
                    *ngIf="
                      !!userId ||
                      this.permissionService.hasPermission(
                        'HABILITAR_MODULO_MANUTENCAO',
                        this.permissions
                      )
                    "
                  >
                    <mat-checkbox
                      formControlName="accessMaintenance"
                      color="primary"
                    >
                      Habilitar módulo de manutenção
                    </mat-checkbox>
                  </div>
                </div>
                <div *ngIf="errorMessage" class="alert alert-danger">
                  {{ errorMessage }}
                </div>

                <div class="form-group mt-2 mb-0 text-center">
                  <back-button></back-button>
                  <button
                    type="submit"
                    [disabled]="!userForm.valid"
                    class="btn ml-0 ml-sm-2 ml-md-3 btn-salvar my-2 my-md-0"
                  >
                    Salvar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab label="Perfil" [disabled]="!userId">
        <ng-template matTabContent>
          <!-- <--[isDetail]="isDetail"-->
          <app-form-aba-perfil [userId]="userId"> </app-form-aba-perfil>
        </ng-template>
      </mat-tab>
      <mat-tab
        label="Nivel acesso modulo de manutenção"
        *ngIf="userForm?.get('accessMaintenance')?.value"
      >
        <ng-template matTabContent>
          <div [formGroup]="userForm">
            <div class="row mt-3 no-gutters p-4 row-form">
              <div class="col-12">
                <h2 class="mb-3">Níveis de acesso - Módulo de manutenção</h2>
                <p class="mb-3">
                  Selecione apenas um nível de acesso por usuário.
                </p>
                <div class="maintenance-levels">
                  <div class="maintenance-levels__header">
                    <span>Nível</span>
                    <span>Ações</span>
                  </div>

                  <mat-radio-group
                    formControlName="maintenanceAccessLevel"
                    class="maintenance-levels__group"
                  >
                    <mat-expansion-panel class="maintenance-levels__panel" #adminMasterPanel [hideToggle]="true">
                    <mat-expansion-panel-header class="maintenance-levels__panel-header">
                      <div class="maintenance-levels__row">
                        <mat-radio-button
                          color="primary"
                          value="ADMIN_MASTER"
                          (click)="$event.stopPropagation()"
                        >
                          Admin Master
                        </mat-radio-button>
                        <button
                          class="maintenance-levels__action-btn"
                          mat-icon-button
                          type="button"
                          matTooltip="Visualizar permissões"
                          (click)="$event.stopPropagation(); adminMasterPanel.toggle()"
                        >
                          <mat-icon>visibility</mat-icon>
                        </button>
                      </div>
                    </mat-expansion-panel-header>
                    <ul class="maintenance-levels__details">
                      <li>Cadastrar, editar e excluir usuários;</li>
                      <li>Gerenciar permissões de acesso;</li>
                      <li>Vincular usuários a empresas;</li>
                      <li>Visualizar e gerenciar todas as empresas cadastradas;</li>
                      <li>Executar todas as funcionalidades disponíveis no módulo.</li>
                    </ul>
                  </mat-expansion-panel>

                    <mat-expansion-panel class="maintenance-levels__panel" #administradorPanel [hideToggle]="true">
                    <mat-expansion-panel-header class="maintenance-levels__panel-header">
                      <div class="maintenance-levels__row">
                        <mat-radio-button
                          color="primary"
                          value="ADMINISTRADOR"
                          (click)="$event.stopPropagation()"
                        >
                          Administrador
                        </mat-radio-button>
                        <button
                          class="maintenance-levels__action-btn"
                          mat-icon-button
                          type="button"
                          matTooltip="Visualizar permissões"
                          (click)="$event.stopPropagation(); administradorPanel.toggle()"
                        >
                          <mat-icon>visibility</mat-icon>
                        </button>
                      </div>
                    </mat-expansion-panel-header>
                    <ul class="maintenance-levels__details">
                      <li>Cadastrar, editar e excluir dados;</li>
                      <li>Gerenciar empresas, responsáveis e veículos vinculados ao seu acesso;</li>
                      <li>Visualizar todas as informações relacionadas ao seu escopo;</li>
                      <li>Executar operações completas dentro das permissões concedidas.</li>
                    </ul>
                  </mat-expansion-panel>

                    <mat-expansion-panel class="maintenance-levels__panel" #editorPanel [hideToggle]="true">
                    <mat-expansion-panel-header class="maintenance-levels__panel-header">
                      <div class="maintenance-levels__row">
                        <mat-radio-button
                          color="primary"
                          value="EDITOR"
                          (click)="$event.stopPropagation()"
                        >
                          Editor
                        </mat-radio-button>
                        <button
                          class="maintenance-levels__action-btn"
                          mat-icon-button
                          type="button"
                          matTooltip="Visualizar permissões"
                          (click)="$event.stopPropagation(); editorPanel.toggle()"
                        >
                          <mat-icon>visibility</mat-icon>
                        </button>
                      </div>
                    </mat-expansion-panel-header>
                    <ul class="maintenance-levels__details">
                      <li>Visualizar dados;</li>
                      <li>Editar informações específicas previamente definidas;</li>
                      <li>Não possui acesso a configurações administrativas ou gerenciamento de usuários.</li>
                    </ul>
                  </mat-expansion-panel>

                    <mat-expansion-panel class="maintenance-levels__panel" #visualizadorPanel [hideToggle]="true">
                    <mat-expansion-panel-header class="maintenance-levels__panel-header">
                      <div class="maintenance-levels__row">
                        <mat-radio-button
                          color="primary"
                          value="VISUALIZADOR"
                          (click)="$event.stopPropagation()"
                        >
                          Visualizador
                        </mat-radio-button>
                        <button
                          class="maintenance-levels__action-btn"
                          mat-icon-button
                          type="button"
                          matTooltip="Visualizar permissões"
                          (click)="$event.stopPropagation(); visualizadorPanel.toggle()"
                        >
                          <mat-icon>visibility</mat-icon>
                        </button>
                      </div>
                    </mat-expansion-panel-header>
                    <ul class="maintenance-levels__details">
                      <li>Visualizar informações de empresas previamente definidas pelo Admin Master;</li>
                      <li>Consultar manutenções, custos e históricos;</li>
                      <li>Não pode realizar edições ou cadastros.</li>
                    </ul>
                    </mat-expansion-panel>
                  </mat-radio-group>
                </div>
                <span
                  class="alert-danger"
                  *ngIf="
                    userForm.get('maintenanceAccessLevel')?.invalid &&
                    userForm.get('maintenanceAccessLevel')?.touched
                  "
                >
                  Selecione um único nível de acesso do módulo de manutenção.
                </span>

                <div class="form-group mt-3 mb-0 text-center">
                  <back-button></back-button>
                  <button
                    type="button"
                    [disabled]="!userForm.valid"
                    (click)="submitMaintenanceTab()"
                    class="btn ml-0 ml-sm-2 ml-md-3 btn-salvar my-2 my-md-0"
                  >
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
